import React from "react";
import { getInitialsImage } from "../../../utils/common";
import DataTable from "../../../components/table/Table";
import Layout from "../../../components/layout/layout";
import Redirect from "../../../assets/icons/redirect.svg";
import { SearchHeader } from "../../../components/seachHeader/SearchHeader";

const AdminPayment = () => {
  const handleSearch = (value: string) => {
    console.log("Searching:", value);
  };

  const dummyData = [
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Jenny Wilson",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$134.55",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Jenny Wilson",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$134.55",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Wade Warren",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$29.99",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Esther Howard",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$76.75",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Tim David",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$134.55",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Guy Hawkins",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$20.99",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Jacob Jones",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$76.75",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Ronald Richards",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$80.00*",
      action: "View in stripe",
    },
    {
      id: "123627898",
      profileImage: null, // Use an image URL or null for initials
      customerName: "Devon Lane",
      startDateTime: "12/23/2024, 07:27:01 PM",
      wallet: "$88.99",
      action: "View in stripe",
    },
  ];

  const columns = [
    { key: "id", label: "ID" },
    {
      key: "customerInfo",
      label: "Customer",
      render: (activity: any) => (
        <div className="flex items-center gap-3">
          {activity.profileImage ? (
            <img
              className="h-10 w-10 rounded-full"
              src={activity.profileImage}
              alt="Profile Image"
            />
          ) : (
            <div className="h-10 w-10 rounded-full bg-orange-500 flex items-center justify-center text-white">
              {getInitialsImage(activity.customerName)}
            </div>
          )}
          <div>{activity.customerName}</div>
        </div>
      ),
    },
    { key: "startDateTime", label: "Start Date & Time" },
    { key: "wallet", label: "Wallet" },
    {
      key: "action",
      label: "Action",
      render: (activity: any) => (
        <a
          href="#"
          className="text-orange-500 underline flex items-center gap-1"
          onClick={() => console.log("Action clicked for", activity.id)}
        >
          {activity.action}
          <img src={Redirect} />
        </a>
      ),
    },
  ];

  return (
    <Layout>
      <div
        className="p-6  mx-auto bg-white  shadow-sm rounded-xl"
        style={{ height: "calc(100vh - 112px)" }}
      >
        <SearchHeader title="Payment" onSearch={handleSearch} />

        <DataTable
          data={dummyData}
          columns={columns}
          itemsPerPage={10}
          // isLoading={fetchLoading}
        />
      </div>
    </Layout>
  );
};

export default AdminPayment;
